import React, { useState, ChangeEvent, FormEvent } from "react";
import { Card } from "primereact/card";
import axios from "axios";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import accountService from "../../services/account/account.service";
import { ResetPasswordDto } from "../../services/account/account.dto";
import { useToast } from "../../utils/toast";
import { Password } from "primereact/password";


const ResetPassword = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const toast = useToast();
  const { uid, token } = useParams<{ uid: string; token: string }>();



  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: ""
    },
    validate: data => {
      const errors: any = {};
      if (!data.password) {
        errors.password = "Şifre gereklidir";
      }
      if (!data.confirmPassword) {
        errors.confirmPassword = "Şifre onayı gereklidir";
      }
      if(data.password !== data.confirmPassword) {
        errors.confirmPassword = "Şifreler uyuşmuyor.";
      }
      return errors;
    },
    onSubmit: async values => {
      try {
        const resetPasswordDto: ResetPasswordDto = {
          uid: uid!,
          token: token!,
          password: values.password
        };
        const response = await accountService.ResetPassword(resetPasswordDto);
        if (response.result && !response.result.error) {
          toast.show("Şifre başarıyla güncellendi.", "success");
          navigate("/loginsebis", { replace: true });
        } else {
          toast.show(response?.result?.error || "Bir hata oluştu", "error");
        }
      } catch (error) {
        toast.show("Bir hata oluştu", "error");
      }
    }
  });

  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
      <div className="flex flex-column align-items-center justify-content-center">
        <div
          style={{
            borderRadius: "56px",
            padding: "0.3rem",
            background: "linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)"
          }}
        >
          <div className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: "53px" }}>
            <div className="text-center mb-5">
              <Link to="/">
                <img src="/images/logoosbuk.png" alt="Image" height="50" className="mb-3" />
              </Link>
              <div className="text-900 text-3xl font-medium mb-3">Şifre Sıfırlama</div>
              <span className="text-600 font-medium">Yeni şifrenizi giriniz</span>
            </div>
            <form onSubmit={formik.handleSubmit} className="mt-5">
              {/* <div className="p-field">
                <label htmlFor="password">Yeni Şifre</label>
                <InputText
                  id="password"
                  name="password"
                  placeholder="E-posta adresiniz"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  className={formik.errors.password ? "p-invalid" : ""}
                />
                {formik.errors.password && <small className="p-error">{formik.errors.password}</small>}

                <label htmlFor="confirmPassword">Şifreyi Onaylayın</label>
              </div> */}

              <div>
                <label htmlFor="password" className="block text-900 font-medium text-xl mb-2 mt-5">
                  {"Şifre"}
                </label>
                <div className="login-password">
                  <Password
                    inputId="password"
                    value={formik.values.password}
                    onChange={e => formik.setFieldValue("password", e.target.value)}
                    placeholder={"Şifrenizi Giriniz"}
                    className="w-full"
                    toggleMask={true}
                    feedback={false}
                    inputClassName="w-full p-3 mr-6 md:mr-0 md:w-30rem"
                  ></Password>
                  {formik.errors.password && <div className="p-error mt-3">{formik.errors.password}</div>}
                </div>

                <label htmlFor="password" className="block text-900 font-medium text-xl mb-2 mt-5">
                  {"Şifre Onayla"}
                </label>
                <div className="login-password">
                  <Password
                    inputId="confirmPassword"
                    value={formik.values.confirmPassword}
                    onChange={e => formik.setFieldValue("confirmPassword", e.target.value)}
                    placeholder={"Şifrenizi Giriniz"}
                    className="w-full"
                    toggleMask={true}
                    feedback={false}
                    inputClassName="w-full p-3 mr-6 md:mr-0 md:w-30rem"
                  ></Password>
                  {formik.errors.confirmPassword && <div className="p-error mt-3">{formik.errors.confirmPassword}</div>}
                </div>
              </div>

              <Button
                type="submit"
                label={loading ? "Yükleniyor..." : "Şifreyi Sıfırla"}
                className="w-full p-3 text-xl mt-5 p-button-lg p-button-block"
                disabled={loading}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
